export const borderRadius = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  pill: '50px',
};

export const shadows = {
  sm: '0 1px 3px rgba(0,0,0,0.08)',
  md: '0 4px 12px rgba(0,0,0,0.1)',
  lg: '0 8px 24px rgba(0,0,0,0.12)',
  xl: '0 16px 48px rgba(0,0,0,0.16)',
  focus: '0 0 0 2px rgba(26,107,74,0.5)',
  destructiveFocus: '0 0 0 2px rgba(239,68,68,0.5)',
  elevated: '0 6px 20px rgba(0,0,0,0.15)',
};

export const spacing = {
  xxs: '4px',
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
  xxxl: '64px',
};

export const transitions = {
  fast: '150ms ease',
  normal: '200ms ease',
  slow: '300ms ease',
};

export const breakpoints = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
};

export const animationDurations = {
  fadeIn: '0.2s',
  slideUp: '0.3s',
  scaleIn: '0.2s',
  shake: '0.4s',
};
